import { Companion_instanceh4txywgfetw1 as Companion_instance } from '../../../../../../okio-parent-okio/okio/HashingSink.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  get3c0ofj2dgi8ma as get,
  HttpMethod_Post_getInstance3lyly75k5cb7q as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstancek26a5f4rdtug as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import {
  toRequestParameters3ovu7e0943da8 as toRequestParameters,
  toMap14rbdrx2whbk6 as toMap,
  toHttpBody2x6lfaxkoi6pf as toHttpBody,
} from '../RequestParameters.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Query2hw717wsl0l5r as Query } from '../Query.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { CacheUrlOverride1zltsak657aw6 as CacheUrlOverride } from './CacheUrlOverride.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sha256($this, $receiver) {
  var hashingSink = Companion_instance.sha256_x3qc5b_k$(blackholeSink());
  var buffer_0 = buffer(hashingSink);
  writeAny(new (BufferedSinkJsonWriter())(buffer_0), $receiver);
  buffer_0.flush_shahbo_k$();
  return hashingSink.get_hash_won4uv_k$().hex_27mj_k$();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.HEADER_APOLLO_REQUIRE_PREFLIGHT_1 = 'Apollo-Require-Preflight';
        this.HEADER_ACCEPT_NAME_1 = 'Accept';
        this.HEADER_ACCEPT_VALUE_DEFER_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.HEADER_ACCEPT_VALUE_MULTIPART_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      appendQueryParameters_p55ht4_k$(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this_0.append_22ad7x_k$(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (hasQuestionMark) {
            this_0.append_58al37_k$(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.append_58al37_k$(_Char___init__impl__6a9atx(63));
          }
          this_0.append_22ad7x_k$(urlEncode(element.get_key_18j28a_k$()));
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(61));
          this_0.append_22ad7x_k$(urlEncode(element.get_value_j01efc_k$()));
        }
        return this_0.toString();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl, enablePostCaching) {
        return new.target.new_com_apollographql_apollo_api_http_DefaultHttpRequestComposer_xvt0v2_k$(serverUrl, enablePostCaching);
      }
      static new_com_apollographql_apollo_api_http_DefaultHttpRequestComposer_xvt0v2_k$(serverUrl, enablePostCaching) {
        var $this = createThis(this);
        $this.serverUrl_1 = serverUrl;
        $this.enablePostCaching_1 = enablePostCaching;
        return $this;
      }
      static new_com_apollographql_apollo_api_http_DefaultHttpRequestComposer_cukmn7_k$(serverUrl) {
        return this.new_com_apollographql_apollo_api_http_DefaultHttpRequestComposer_xvt0v2_k$(serverUrl, false);
      }
      compose_vpsqtm_k$(apolloRequest) {
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        if (!(apolloRequest.httpHeaders_1 == null)) {
          this_0.addAll_h3ej1q_k$(apolloRequest.httpHeaders_1);
        }
        if (get(this_0, 'accept') == null) {
          var tmp;
          var tmp_0 = apolloRequest.operation_1;
          if (isInterface(tmp_0, Subscription())) {
            tmp = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
          } else {
            tmp = 'application/graphql-response+json, application/json';
          }
          this_0.add_utx5q5_k$(new (HttpHeader())('accept', tmp));
        }
        var requestHeaders = this_0;
        var requestParameters = toRequestParameters(apolloRequest);
        var tmp0_elvis_lhs = apolloRequest.url_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.serverUrl_1 : tmp0_elvis_lhs;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "ApolloRequest.url is missing for request '" + apolloRequest.operation_1.operationName() + "', did you call ApolloClient.Builder.serverUrl(url)?";
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        var url = tmp_1;
        var tmp2_elvis_lhs = apolloRequest.httpMethod_1;
        var tmp_2;
        switch ((tmp2_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp2_elvis_lhs).ordinal_1) {
          case 0:
            tmp_2 = (new (Builder())(HttpMethod_Get_getInstance(), Companion_instance_0.appendQueryParameters_p55ht4_k$(url, asGetParameters(toMap(requestParameters))))).addHeader_jobub6_k$('Apollo-Require-Preflight', 'true');
            break;
          case 1:
            var body = toHttpBody(requestParameters);
            // Inline function 'kotlin.apply' call

            var this_1 = new (Builder())(HttpMethod_Post_getInstance(), url);
            this_1.body_3hhs87_k$(body);
            if (startsWith(body.get_contentType_7git4a_k$(), 'multipart/form-data')) {
              this_1.addHeader_jobub6_k$('Apollo-Require-Preflight', 'true');
            }

            var operation = apolloRequest.operation_1;
            var tmp_3;
            if (this.enablePostCaching_1) {
              tmp_3 = isInterface(operation, Query());
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              // Inline function 'kotlin.collections.mutableMapOf' call
              var cacheParameters = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!requestParameters.variables_1.isEmpty_y1axqb_k$()) {
                cacheParameters.put_4fpzoq_k$('variablesHash', sha256(this, requestParameters.variables_1));
              }
              cacheParameters.put_4fpzoq_k$('operationName', operation.operationName());
              cacheParameters.put_4fpzoq_k$('operationId', operation.operationId());
              this_1.addExecutionContext_c49mf3_k$(new (CacheUrlOverride())(Companion_instance_0.appendQueryParameters_p55ht4_k$(url, cacheParameters)));
            }

            tmp_2 = this_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_2;
        return httpRequestBuilder.addHeaders_2d4x0x_k$(requestHeaders).addExecutionContext_c49mf3_k$(apolloRequest.executionContext_1).build_1k0s4u_k$();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function asGetParameters(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(_this__u8e3s4.get_size_woubt6_k$()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = _this__u8e3s4.get_entries_p20ztl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var tmp = element.get_key_18j28a_k$();
    var v = element.get_value_j01efc_k$();
    var tmp_0;
    if (!(v == null) ? typeof v === 'string' : false) {
      tmp_0 = v;
    } else {
      // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
      var buffer = new (Buffer())();
      var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
      writeAny($this$buildJsonString, v);
      tmp_0 = buffer.readUtf8_echivt_k$();
    }
    var tmp$ret$4 = tmp_0;
    destination.put_4fpzoq_k$(tmp, tmp$ret$4);
  }
  return destination;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.get_entries_p20ztl_k$();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$4 = to(index_0.toString(), listOf(item.get_key_18j28a_k$()));
    destination.add_utx5q5_k$(tmp$ret$4);
  }
  writeAny($this$buildJsonByteString, toMap_0(destination));
  return buffer.readByteString_nzt46n_k$();
}
function writeBoundaries($this, $receiver, writeUploadContents) {
  $receiver.writeUtf8_9rv3au_k$('--' + $this.boundary_1 + '\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Disposition: form-data; name="operations"\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Type: application/json\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Length: ' + $this.operationByteString_1.get_size_woubt6_k$() + '\r\n');
  $receiver.writeUtf8_9rv3au_k$('\r\n');
  $receiver.write_nkn6vw_k$($this.operationByteString_1);
  var uploadsMap = buildUploadMap($this, $this.uploads_1);
  $receiver.writeUtf8_9rv3au_k$('\r\n--' + $this.boundary_1 + '\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Disposition: form-data; name="map"\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Type: application/json\r\n');
  $receiver.writeUtf8_9rv3au_k$('Content-Length: ' + uploadsMap.get_size_woubt6_k$() + '\r\n');
  $receiver.writeUtf8_9rv3au_k$('\r\n');
  $receiver.write_nkn6vw_k$(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.uploads_1.get_values_ksazhn_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    $receiver.writeUtf8_9rv3au_k$('\r\n--' + $this.boundary_1 + '\r\n');
    $receiver.writeUtf8_9rv3au_k$('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.get_fileName_r258mo_k$() == null)) {
      $receiver.writeUtf8_9rv3au_k$('; filename="' + item.get_fileName_r258mo_k$() + '"');
    }
    $receiver.writeUtf8_9rv3au_k$('\r\n');
    $receiver.writeUtf8_9rv3au_k$('Content-Type: ' + item.get_contentType_7git4a_k$() + '\r\n');
    var contentLength = item.get_contentLength_a5o8yy_k$();
    if (!(contentLength === -1n)) {
      $receiver.writeUtf8_9rv3au_k$('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    $receiver.writeUtf8_9rv3au_k$('\r\n');
    if (writeUploadContents) {
      item.writeTo_nko22i_k$($receiver);
    }
  }
  $receiver.writeUtf8_9rv3au_k$('\r\n--' + $this.boundary_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return constructCallableReference((p0) => p0.get_contentLength_a5o8yy_k$(), 1, 0, 204);
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.uploads_1 = uploads;
        this.operationByteString_1 = operationByteString;
        this.boundary_1 = uuid4().toString();
        this.contentType_1 = 'multipart/form-data; boundary=' + this.boundary_1;
        var tmp = this;
        tmp.contentLength$delegate_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.flush_shahbo_k$();
          var tmp = countingSink.bytesWritten_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.uploads_1.get_values_ksazhn_k$().iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            var tmp_0 = sum;
            var tmp$ret$1 = element.get_contentLength_a5o8yy_k$();
            sum = add(tmp_0, tmp$ret$1);
          }
          var tmp$ret$0 = sum;
          var result = add(tmp, tmp$ret$0);
          return result;
        });
      }
      get_contentType_7git4a_k$() {
        return this.contentType_1;
      }
      get_contentLength_a5o8yy_k$() {
        var tmp0 = this.contentLength$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.get_value_j01efc_k$();
      }
      writeTo_nko22i_k$(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.delegate_1 = delegate;
        this.bytesWritten_1 = 0n;
      }
      write_kzgu6x_k$(source, byteCount) {
        this.delegate_1.write_kzgu6x_k$(source, byteCount);
        this.bytesWritten_1 = add(this.bytesWritten_1, byteCount);
      }
      flush_shahbo_k$() {
        this.delegate_1.flush_shahbo_k$();
      }
      close_yn9xrc_k$() {
        this.delegate_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  UploadsHttpBody as UploadsHttpBody13sq2iwgyese9,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
